import { GET } from "../@client/api"
import { SelectEntity, SelectEntityProps } from "./entity-select"
//ToDo: Optionen zum filtern der Abteilungen (Berechtigung/Module etc)

interface Props<TURL extends keyof GET>
  extends Omit<SelectEntityProps<TURL>, "url" | "getId" | "getLabel"> {}

export function DepartmentSelect({
  ...props
}: Props<"/api/Department/GetPersoListWithRosterReadPermission">) {
  return (
    <SelectEntity
      url="/api/Department/GetPersoListWithRosterReadPermission"
      getId={(v) => v.departmentId}
      getLabel={(v) => v.name}
      {...props}
    />
  )
}
